import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { SocketsService } from './sockets.service';
import { VesselStateResponse } from '@core/api/state-api.service';

@Injectable({
  providedIn: 'root',
})
export class VesselsStateSocketsService {
  private unsubscribe$ = new Subject<void>();

  constructor(private _commonSockets: SocketsService) {}

  public createIotConnection(): Observable<VesselStateResponse> {
    const room = 'state';
    const socket = this._commonSockets.getSocket();

    this.subscribeToRoom(socket, room);

    return new Observable<VesselStateResponse>((observer) => {
      socket.on(room, (data: VesselStateResponse) => {
        if (data) {
          observer.next(data);
        } else {
          console.error('WS ERROR: Unable to reach server');
          observer.error('UNABLE TO REACH SERVER');
        }
      });

      socket.on('reconnect', () => {
        this._commonSockets.logConnectionEvent('Reconnected');
        this.subscribeToRoom(socket, room);
      });

      socket.on('disconnect', (reason) => {
        this._commonSockets.logConnectionEvent(`Disconnected: ${reason}`);
      });

      return () => {
        socket.emit('unsubscribe', room, (response) => {
          console.log('Unsubscribed from STATE', response);
        });

        this.unsubscribe$.next();
        this.unsubscribe$.complete();
      };
    });
  }

  private subscribeToRoom(socket: any, room: string): void {
    socket.emit('subscribeState', room, () => {
      console.log(`Subscribed to room: ${room}`);
    });
  }
}
